import {
  AuthenticationContext,
  AuthenticationConsumer,
  AuthenticationProvider
} from './authentication-context';

export { AuthenticationContext, AuthenticationConsumer, AuthenticationProvider };

export default AuthenticationContext;
